import { MetricContainer, MetricsRow } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";
import React from "react";
import { connect } from "react-redux";
import DurationService from "app/services/DurationService";
import { PaidTopKeywords } from "../WWOTopKeywords";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { useCurrentStateAndParams } from "@uirouter/react";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

const WWOSearchTrafficPaid = (props) => {
    const { getKeywordsCtaLink, showGAApprovedData, keywordsUnlockHook = null } = props;
    const { params, state } = useCurrentStateAndParams();
    // set webSource to "Total" for WWOSearchTrafficPaid since it is the only webSource available component
    const webSource = devicesTypes.TOTAL;
    const { country, key, isWWW, duration } = params;
    const configId = proNavigator.getConfigId(state);
    const { forAPI } = DurationService.getDurationData(duration, undefined, configId);
    const { from, to, isWindow } = forAPI;
    const queryParams = React.useMemo(
        () => ({
            country,
            from,
            includeSubDomains: isWWW === "*",
            isWindow,
            keys: key,
            to,
            webSource,
        }),
        [country, from, isWindow, key, to, isWWW],
    );
    const [noDataState, setNoDataState] = React.useState({ TopAds: false, topKeywordsPaid: false });
    const commonProps = { queryParams, noDataState, setNoDataState };

    if (!key) {
        return;
    }
    return (
        <MetricsRow>
            <MetricContainer
                width={"100%"}
                height={"305px"}
                padding={0}
            >
                <PaidTopKeywords
                    {...commonProps}
                    routingParams={{ ...params, showGAApprovedData }}
                    getCtaLink={getKeywordsCtaLink}
                    unlockHook={keywordsUnlockHook}
                />
            </MetricContainer>
        </MetricsRow>
    );
};

const mapStateToProps = (props) => {
    const { common } = props;
    const { showGAApprovedData } = common;
    return {
        showGAApprovedData,
    };
};

export default connect(mapStateToProps)(WWOSearchTrafficPaid);
